import { Component, Input } from '@angular/core';
import { FlexLayoutModule } from 'ngx-flexible-layout';

export interface TypeObject {
  button: string;
  page: string;
}
export interface Loading {
  button?: boolean;
  button2?: boolean;
  button3?: boolean;
  page?: boolean;
  page2?: boolean;
}

@Component({
  selector: 'app-loader',
  imports: [FlexLayoutModule],
  templateUrl: './loader.html',
  styleUrl: './loader.scss'
})
export class Loader {
  /**
 * Variable which used to define the loader type received from parent component.
 */
  @Input() public readonly type: string = 'Button';
  /**
   * Variable which is used to define the loader type.
   */
  public readonly loaderType: TypeObject = { button: 'Button', page: 'Page' };

}
